import React from 'react'

function URLReplacer({ text }) {
  const replaceUrlWithHtml = (text) => {
    const urlPattern = /(https?:\/\/\S+)/g;
    return text.replace(urlPattern, '<a href="$1" target="_blank" class="underline">here</a>');
  };

  const modifiedText = text.includes('https://') ? replaceUrlWithHtml(text) : text;

  return modifiedText.includes('<a') ? (
      <span dangerouslySetInnerHTML={{ __html: modifiedText }} />
  ) : (
      <>{modifiedText}</>
  );
}

export default URLReplacer
